import _ from 'lodash';
import BaseModel from '../models/BaseModel';
import MarketModel from '../models/agent/market/market-model';
import OutcomeModel from '../models/agent/outcome/outcome-model';

export const isEmpty = value =>
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0);
// (typeof value === 'string' && value.trim().length === 0);

export const coalesce = (...values) => {
    const nonEmpty = values.find(v => !isEmpty(v));
    return typeof nonEmpty !== 'undefined' ? nonEmpty : null;
};

export const mergeMarkets = (currentMarkets, newMarkets) => {
    let currentCopy = _.cloneDeep(currentMarkets);
    let newCopy = _.cloneDeep(newMarkets);
    currentCopy = _.keyBy(currentCopy, 'id');
    newCopy = _.keyBy(newCopy, 'id');

    Object.keys(currentCopy).forEach(currentKey => {
        if (!isEmpty(newCopy[currentKey])) {
            if (newCopy[currentKey].outcomes) {
                if (!currentCopy[currentKey].outcomes?.length) {
                    currentCopy[currentKey].outcomes = [...newCopy[currentKey].outcomes];
                } else {
                    const currentOutcomesByKey = _.keyBy(
                        currentCopy[currentKey].outcomes,
                        'outcomeRefId',
                    );

                    currentCopy[currentKey].outcomes = newCopy[currentKey].outcomes.map(outcome => {
                        let currentOutcome = currentOutcomesByKey[outcome.outcomeRefId];

                        if (currentOutcome) {
                            let oddChangeType = '';

                            if (outcome.odd > currentOutcome.odd) {
                                oddChangeType = 'increase';
                            } else if (outcome.odd < currentOutcome.odd) {
                                oddChangeType = 'decrease';
                            }

                            return BaseModel.merge(OutcomeModel, currentOutcome, outcome, {
                                changeType: oddChangeType,
                            });
                        } else {
                            return outcome;
                        }
                    });
                }
            }

            if (newCopy[currentKey].specifiers && newCopy[currentKey].specifiers.length > 0) {
                currentCopy[currentKey].specifiers = [...newCopy[currentKey].specifiers];
            }

            delete newCopy[currentKey].outcomes;
            delete newCopy[currentKey].specifiers;

            if (!currentCopy.specifiers) {
                currentCopy.specifiers = currentCopy.specifiers || [];
            }

            currentCopy[currentKey] = BaseModel.merge(
                MarketModel,
                currentCopy[currentKey],
                newCopy[currentKey],
            );
        }

        delete newCopy[currentKey];
    });

    currentCopy = _.values({ ...currentCopy, ...newCopy });

    return currentCopy;
};
